// extracted by mini-css-extract-plugin
export var productImage = "_mu-1";
export var viewLink = "_mu-2";
export var wishlistItem = "_mu-0";